import React, { useState, useEffect } from "react";
import { Button, Tooltip } from "@mui/material";
import HistoryIcon from "@mui/icons-material/History";
import CustomTable from "../../components/customTable/CustomTable";
import { useSnackbar } from "notistack";
import { useAdminContext } from "../../Hooks/AdminContext";
import StatusChip from "../../theme/chip";
import { useNavigate } from "react-router-dom";
import roundFilterList from "@iconify/icons-ic/round-filter-list";
import FilteredChip from "../../components/FilteredChip";
import { Icon } from "@iconify/react/dist/iconify.js";
import CustomDrawer from "../../components/CustomDrawer";
import TransactionsFilter from "./TransactionsFilter";
import { _List_Transaction_For_Admin } from "../../DAL/Listing/TransactionList";
import CustomCircularProgress from "../../components/CustomCircularProgress";
import { formatNumber, show_proper_words } from "../../utils/constant";
import moment from "moment";
import { Scree_Base_List } from "../../DAL/Listing/AgencyAddAcount";

const WalletTransactionsList = () => {
  const { setnavbarTitle } = useAdminContext();
  const { enqueueSnackbar } = useSnackbar();
  const [filterDrawerState, setFilterDrawerState] = useState(false);
  const EMPTY_FILTER = {
    user: "",
    payment_made_by: "",
  };
  const [filterData, setFilterData] = useState(EMPTY_FILTER);
  const [filterStateUpdated, setFilterStateUpdated] = useState(EMPTY_FILTER);
  const [userList, setUserList] = useState([]);
  const [selectUsersList, setSelectUsersList] = useState([]);
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [totalCount, setTotalCount] = useState(userList.length);
  const [pageCount, setPageCount] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(true);

  /**
   * handleOpenFilterDrawer - Opens the filter drawer.
   *
   * This function sets the `filterDrawerState` to `true`, which triggers the display of the filter drawer.
   */
  const handleOpenFilterDrawer = () => {
    setFilterDrawerState(true);
  };

  /**
   * searchFunction - Handles the search operation and updates the transaction list.
   *
   * This function resets the page to 0, sets the total pages to 1, stores the search text and filter data
   * in local storage, and triggers the `getWalletTransactionsList` function to fetch the filtered transactions.
   * It then closes the filter drawer.
   */
  const searchFunction = (e) => {
    setPage(0);
    setTotalPages(1);
    localStorage.setItem("Wallet_Transaction_Search_Text", searchText);
    localStorage.setItem(
      "Filter_Data_Wallet_Transaction",
      JSON.stringify(filterData)
    );
    getWalletTransactionsList(0, rowsPerPage, filterData, searchText);
    handleCloseFilterDrawer();
  };

  // This function handles page changes for pagination.
  // It updates the page state to the new page number and adjusts the page count accordingly.
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    if (newPage <= 0) {
      setPageCount(1);
    } else {
      setPageCount(newPage + 1);
    }
  };

  // This function handles changes in the number of rows per page for pagination.
  // It updates the rowsPerPage state to the new value and resets the page state to 0.
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // This function handles the page change for pagination.
  // If the new page is less than or equal to 0, it resets the page to 0 and sets the page count to 1.
  // Otherwise, it updates the page state to the new page and adjusts the page count accordingly.
  const handleChangePages = (event, newPage) => {
    if (newPage <= 0) {
      setPage(0);
      setPageCount(1);
    } else {
      setPage(newPage - 1);
      setPageCount(newPage);
    }
  };

  const User_Table_Head = [
    {
      id: "action",
      label: "Action",
      renderData: (row) => (
        <>
          <Tooltip title="View History" placement="top">
            <HistoryIcon
              onClick={() => {
                navigate(
                  `/wallet-transactions/wallet-transaction-history/${row._id}`
                );
              }}
              style={{
                fill: "#fff",
                marginRight: "10px",
                cursor: "pointer",
              }}
            />
          </Tooltip>
        </>
      ),
    },
    {
      id: "number",
      label: "#",
      type: "number",
    },
    {
      id: "name",
      label: "User",
      renderData: (row) => (
        <div
        // className="pointer"
        // onClick={() => {
        //   setOpenModal(true);
        // }}
        >
          <div className="capitalized">
            {row.user_info.first_name + " " + row.user_info.last_name || "_ _"}
          </div>
          <div className="text-muted" style={{ fontSize: "0.9em" }}>
            {row.user_info.email || "_ _"}
          </div>
        </div>
      ),
    },
    {
      id: "deposit_method",
      label: "Deposit Method",
      renderData: (row) => (
        <div>
          {row.deposit_method === "crypto"
            ? "Crypto Transfer"
            : row.deposit_method === "credit_card"
            ? "Credit Card Transfer"
            : show_proper_words(row.deposit_method) || "_ _"}
        </div>
      ),
    },
    {
      id: "amount",
      label: "Processor Type",
      renderData: (row) => (
        <div>{show_proper_words(row.processed_fee_type) || "N/A"}</div>
      ),
    },
    {
      id: "amount",
      label: "Total Amount",
      renderData: (row) => <div>${formatNumber(row.total_amount) || "0"}</div>,
    },
    {
      id: "amount",
      label: "Amount Sent",
      renderData: (row) => <div>${formatNumber(row.amount) || "0"}</div>,
    },
    {
      id: "",
      label: "Processor Fees",
      renderData: (row) => <div>${formatNumber(row.processed_fee) || "0"}</div>,
    },
    {
      id: "",
      label: "Request Type",
      renderData: (row) => (
        <div>
          {show_proper_words(
            row.transaction_for === "manual"
              ? "Deposit Request"
              : row.transaction_for === "one_time"
              ? "Credit Card Payment"
              : row.transaction_for
          ) || "N/A"}
        </div>
      ),
    },
    {
      id: "transaction_date",
      label: "Transaction Date",
      renderData: (row) => (
        <div>{moment(row.date_time).format("DD MMM YY hh:mm A") || "_ _"}</div>
      ),
    },
    {
      id: "status",
      label: "Status",
      renderData: (row) => (
        <StatusChip
          status={row.status === "succeeded" ? "Approved" : ""}
          type="activeInactive"
        />
      ),
    },
  ];

  /**
   * handleClearFilter - Clears the applied filters and resets the transaction list.
   *
   * This function removes the stored filter data from local storage, resets the filter state and pagination,
   * and triggers the `getWalletTransactionsList` function to fetch transactions with no filters.
   * It then closes the filter drawer.
   */
  const handleClearFilter = () => {
    localStorage.removeItem("Filter_Data_Wallet_Transaction");
    setFilterData(EMPTY_FILTER);
    setFilterStateUpdated(EMPTY_FILTER);
    setPage(0);
    setPageCount(1);
    getWalletTransactionsList(0, rowsPerPage, EMPTY_FILTER, searchText);
    handleCloseFilterDrawer();
  };

  /**
   * handleChangeOthers - Updates the filter data with new values.
   *
   * This function modifies the filter state by updating the specified field (`name`) with the provided `value`.
   * It ensures the current filter data is preserved while only updating the specified property.
   */
  const handleChangeOthers = (name, value) => {
    setFilterData((values) => ({ ...values, [name]: value }));
  };

  /**
   * handleCloseFilterDrawer - Closes the filter drawer.
   *
   * This function sets the `filterDrawerState` to `false`, effectively closing the filter drawer UI.
   */
  const handleCloseFilterDrawer = () => {
    setFilterDrawerState(false);
  };

  /**
   * HandleDeleteChip - Handles the deletion of a filter chip and updates the transaction list.
   *
   * This function ensures that the filter data is correctly reset when a chip is deleted, setting default empty values
   * for `user` and `payment_made_by` if they are not present. It updates the filter state and persists the changes to
   * localStorage, then triggers the wallet transaction list refresh based on the updated filter data.
   */
  const HandleDeleteChip = (data) => {
    if (!data.user) {
      data.user = "";
    }
    if (!data.payment_made_by) {
      data.payment_made_by = "";
    }
    setPage(0);
    getWalletTransactionsList(0, rowsPerPage, data, searchText);
    setFilterData(data);
    localStorage.setItem(
      "Filter_Data_Wallet_Transaction",
      JSON.stringify(data)
    );
  };

  /**
   * getWalletTransactionsList - Fetches the wallet transaction list based on filters, search, and pagination.
   *
   * This function prepares the data by collecting the filter and search criteria, making an API call to retrieve
   * the list of transactions, and updates the state with the results. It also handles the processing of chip data
   * to display in the UI, including user and payment method information, and updates pagination details.
   */
  const getWalletTransactionsList = async (
    page,
    rowsPerPage,
    filterData,
    search
  ) => {
    const PostData = { ...filterData };
    PostData.search = search;
    // console.log(PostData);

    const formData = {
      type: "transaction",
      user_id: filterData?.user?.id || "",
      // status: filterData?.status || "",
      payment_method: filterData?.payment_made_by || "",
    };
    setLoading(true);
    const response = await _List_Transaction_For_Admin(
      formData,
      page,
      rowsPerPage
    );
    if (response.code === 200) {
      const { total_count, total_pages, transaction = [] } = response;
      let chipData = { ...filterData };
      if (chipData?.user?.id) {
        chipData.user = {
          chip_label: chipData?.user?.name,
          chip_value: chipData?.user?.id,
        };
      }
      if (chipData.payment_made_by) {
        chipData.payment_made_by = show_proper_words(chipData.payment_made_by);
      }
      setFilterStateUpdated(chipData);
      setTotalCount(total_count);
      setTotalPages(total_pages);
      setUserList(transaction);
      setLoading(false);
    } else {
      setLoading(false);
      enqueueSnackbar(response.message, { variant: "error" });
    }
  };

  /**
   * handleGetDetailUser - Fetches customer details based on a search value and formats the response.
   *
   * This function sends a request to retrieve customer data using a search query. It then formats the list of
   * customers, extracting relevant details such as user ID, name, and email, and updates the state with the
   * formatted data for use in the UI.
   */
  const handleGetDetailUser = async (value) => {
    const FormData = {
      type: "customer",
      search: value,
    };
    const response = await Scree_Base_List(FormData);
    if (response.code === 200) {
      const FormatData = response?.list?.map((value) => {
        return {
          id: value.user_id,
          name: show_proper_words(value.first_name + " " + value.last_name),
          email: value.email,
        };
      });
      setSelectUsersList(FormatData);
    }
  };

  /**
   * useEffect - Initializes wallet transactions on component mount and handles filter state and search.
   *
   * This hook is triggered whenever the page or rowsPerPage changes. It sets the navbar title to "Wallet Transactions",
   * retrieves any stored filter data from localStorage, and updates the filter state accordingly. It also calls the function
   * to fetch wallet transactions using the appropriate filters and search text, ensuring the data is displayed correctly.
   */
  useEffect(() => {
    handleGetDetailUser();
    setnavbarTitle("Wallet Transactions");
    const StoredFilter =
      JSON.parse(localStorage.getItem("Filter_Data_Wallet_Transaction")) || {};
    const search = localStorage.getItem("Wallet_Transaction_Search_Text");
    if (Object.keys(StoredFilter).length > 0) {
      setFilterData(StoredFilter);
    }
    const finalFilter =
      Object.keys(StoredFilter).length > 0 ? StoredFilter : filterData;
    getWalletTransactionsList(page, rowsPerPage, finalFilter, search || "");
    if (search) setSearchText(search);
  }, [page, rowsPerPage]);

  if (loading) {
    return <CustomCircularProgress />;
  }

  return (
    <div className="mt-3">
      <div className="row mb-3">
        <div className="col-12 col-md-10">
          <FilteredChip
            data={filterStateUpdated}
            tempState={filterData}
            EMPTY_FILTER={EMPTY_FILTER}
            onDeleteChip={HandleDeleteChip}
            onClear={handleClearFilter}
          />
        </div>
        <div className="col-12 col-md-2 text-end">
          <Button variant="contained" onClick={handleOpenFilterDrawer}>
            Filters &nbsp;&nbsp; <Icon icon={roundFilterList} />
          </Button>
        </div>
      </div>
      <CustomTable
        data={userList}
        TABLE_HEAD={User_Table_Head}
        MENU_OPTIONS={[]}
        // custom_search={{
        //   searchText: searchText,
        //   setSearchText: setSearchText,
        //   handleSubmit: searchFunction,
        // }}
        custom_pagination={{
          total_count: totalCount,
          rows_per_page: rowsPerPage,
          page: page,
          handleChangePage: handleChangePage,
          onRowsPerPageChange: handleChangeRowsPerPage,
        }}
        pageCount={pageCount}
        totalPages={totalPages}
        handleChangePages={handleChangePages}
        pagePagination={true}
        is_hide={true}
      />
      <CustomDrawer
        isOpenDrawer={filterDrawerState}
        onOpenDrawer={handleOpenFilterDrawer}
        onCloseDrawer={handleCloseFilterDrawer}
        pageTitle="Filters"
        componentToPassDown={
          <TransactionsFilter
            userList={selectUsersList}
            handleGetDetailUser={handleGetDetailUser}
            filterData={filterData}
            handleClearFilter={handleClearFilter}
            handleChangeOthers={handleChangeOthers}
            searchSubmitFilter={searchFunction}
            setFilterData={setFilterData}
          />
        }
      />
    </div>
  );
};

export default WalletTransactionsList;
